export default __webpack_public_path__ + "static/media/upload.79d1fdcd.svg";